"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Module = void 0;
class Module {
    _submodules;
    constructor(submodules = []) {
        this._submodules = new Map();
        for (const submodule of submodules) {
            this._submodules.set(submodule.constructor.name, submodule);
        }
    }
    onInit() {
        // To be implemented by module
    }
    init() {
        this.onInit();
        for (const submodule of this._submodules.values()) {
            submodule.init();
        }
    }
    getSubmodule(submodule) {
        return this._submodules.get(submodule.name);
    }
    onDispose() {
        // To be implemented by module
    }
    dispose() {
        this.onDispose();
        for (const submodule of this._submodules.values()) {
            submodule.dispose();
        }
    }
}
exports.Module = Module;
